import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "72",
  height: "72",
  viewBox: "0 0 72 72",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "icon-ui-nav-find-friends", -1),
    _createElementVNode("path", {
      d: "M19.284 59.692L8.634 69.01a4 4 0 1 1-5.268-6.02l10.08-8.82A32.94 32.94 0 0 1 5.85 33.075C5.849 14.808 20.657 0 38.924 0 57.192 0 72 14.808 72 33.076 72 51.343 57.192 66.15 38.924 66.15c-7.354 0-14.147-2.4-19.64-6.46zm19.64-1.01c14.143 0 25.607-11.464 25.607-25.606 0-14.143-11.464-25.607-25.607-25.607-14.142 0-25.607 11.464-25.607 25.607 0 14.142 11.465 25.607 25.607 25.607zM26 38H52.53c-2.691 8.844-7.113 13.266-13.265 13.266C33.113 51.266 28.692 46.844 26 38zm4.422-9.156a4.422 4.422 0 1 1 0-8.844 4.422 4.422 0 0 1 0 8.844zm17 0a4.422 4.422 0 1 1 0-8.844 4.422 4.422 0 0 1 0 8.844z",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render: render }